import { Component, inject } from '@angular/core';
import { ScrollToTopComponent } from '../scroll-to-top/scrollToTop';
import { I18nService } from '../../services/i18n.service';
import { NavButtonComponent } from '../nav-button/nav-button';
import { Router } from '@angular/router';
import { I18N_KEYS } from '../../enums/i18.enum';
import { App_Routes } from '../../enums/router.enum';

@Component({
  selector: 'app-imprint',
  imports: [ScrollToTopComponent, NavButtonComponent],
  templateUrl: './imprint.html',
  styleUrls: ['./imprint.scss'],
})
export class ImprintComponent {
  public i18n = inject(I18nService);
  private router = inject(Router);
  public imprintData: any[] = [
    {
      title: this.i18n.langString(I18N_KEYS.SERVICE_PROVIDER_TITLE),
      content: this.i18n.langString(I18N_KEYS.SERVICE_PROVIDER),
    },
    {
      title: this.i18n.langString(I18N_KEYS.REGISTERED_OFFICE_TITLE),
      content: this.i18n.langString(I18N_KEYS.REGISTERED_OFFICE),
    },
    {
      title: this.i18n.langString(I18N_KEYS.POSTAL_ADDRESS_TITLE),
      content: this.i18n.langString(I18N_KEYS.POSTAL_ADDRESS),
    },
    {
      title: this.i18n.langString(I18N_KEYS.COMMERCIAL_REGISTERD_TITLE),
      content: this.i18n.langString(I18N_KEYS.COMMERCIAL_REGISTER),
    },
    {
      title: this.i18n.langString(I18N_KEYS.VAT_ID_NO_TITLE),
      content: this.i18n.langString(I18N_KEYS.VAT_ID_NO),
    },
    {
      title: this.i18n.langString(I18N_KEYS.EMAIL_CONTACT_TITLE),
      content: this.i18n.langString(I18N_KEYS.EMAIL_CONTACT),
    },
  ];

  gotoLogin() {
    if (this.router.url.includes('settings')) {
      this.router.navigate([App_Routes.SETTINGS]);
    } else {
      this.router.navigate([App_Routes.LOGIN]);
    }
  }
}
